import React from "react";
import PropTypes from "prop-types";

import ProductSelection from "../components/ProductSelection/ProductSelection";
import MiniSteps from "../../../../components/MiniSteps/MiniSteps";
import useSkrillViewModel, {ViewMode} from "./Skrill.vm";
import PaymentRequestForm from "./components/PaymentRequestForm/PaymentRequestForm";
import TransactionProcessing from "./components/TransactionProcessing/TransactionProcessing";
import TransactionCompleted from "../components/TransactionCompleted/TransactionCompleted";
import TransactionFailed from "../components/TransactionFailed/TransactionFailed";
import "./Skrill.scss";

const SkrillContext = React.createContext({});

const Skrill = (props)=>{

    const vm = useSkrillViewModel(props);
    return (
        <div className={"Skrill AddFundsContent step_" + vm.viewMode + ""}>
            <SkrillContext.Provider value={vm}>
                {{
                    [ViewMode.PRODUCT_SELECTION]: ()=><ProductSelection vm={vm} parlayContext={props.parlayContext} />,
                    [ViewMode.PAYMENT_REQUEST_FORM]: ()=><PaymentRequestForm vm={vm}
                                                                           style={{display: vm.submitting ? 'none' : 'block'}}/>,
                    [ViewMode.TRANSACTION_PROCESSING]:()=><TransactionProcessing vm={vm}/>,
                    [ViewMode.TRANSACTION_COMPLETED]:()=><TransactionCompleted vm={vm}/>,
                    [ViewMode.TRANSACTION_FAILED]:()=><TransactionFailed vm={vm}/>
                }[vm.viewMode]()}
            </SkrillContext.Provider>
        </div>)
}

Skrill.propTypes = {
    showCloseBtn: PropTypes.bool,
    close: PropTypes.func,
};

export default Skrill;